import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import ResourceAllocationForm from '../../components/Resources/ResourceAllocationForm';
import './ResourceAllocationCreate.css';

const ResourceAllocationEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const handleSuccess = () => {
    navigate('/app/resources');
  };

  const handleCancel = () => {
    navigate('/app/resources');
  };

  return (
    <div className="resource-allocation-create-page">
      <div className="page-header">
        <button className="back-button" onClick={() => navigate('/app/resources')}>
          <FiArrowLeft /> Back to Resources
        </button>
        <h1>Edit Resource Allocation</h1>
        <p>Update team member assignment</p>
      </div>

      <ResourceAllocationForm
        allocationId={id}
        onSuccess={handleSuccess}
        onCancel={handleCancel}
      />
    </div>
  );
};

export default ResourceAllocationEdit;

